import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import type { BranchPayrollReadiness } from "@/hooks/useBranchPayrollReadiness";

/**
 * The branch's payroll policy leaves days outside every pay period (D3). Not
 * a blocker: the run works, but those days' attendance, overtime and joiners
 * are never counted, so HR should fix the policy.
 */
export const PayrollPeriodGapNotice = ({
  readiness,
}: {
  readiness: BranchPayrollReadiness;
}) => {
  const { t } = useTranslation("company");
  if (!readiness.payrollPeriodIssue) return null;
  return (
    <div className="flex items-start gap-2.5 rounded-xs border border-warning-muted bg-warning-muted/40 px-4 py-3">
      <AlertTriangle className="mt-0.5 size-4 shrink-0 text-warning" />
      <div className="flex flex-col gap-1 text-xs text-foreground">
        <span>
          {readiness.payrollPeriodIssue === "SAME_MONTH_GAP"
            ? t("payrolls.period_gap_same_month")
            : t("payrolls.period_gap_cross_month")}
        </span>
        <Link
          to={readiness.settingsHref}
          className="font-semibold text-primary hover:underline"
        >
          {t("payrolls.open_branch_payroll_settings")}
        </Link>
      </div>
    </div>
  );
};
